import { useMutation } from '@tanstack/react-query';
import oAuthClient from './core';

export const isLogged = () => Boolean(sessionStorage.getItem('token'));

export default function useAuthStatusMutation() {
  return useMutation({
    mutationFn: async () => {
      const response = await oAuthClient.fetchAuthStatus();

      return response;
    },
    onSuccess() {
      sessionStorage.setItem('token', 'kc');
    },
  });
}
